// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"SideMenu_menuIcon__1SFRo","isOpen":"SideMenu_isOpen__5HgxI"};